





























import Component, { mixins } from "vue-class-component";
import { Location } from "vue-router";
import WithAuthUser from "@/mixins/WithAuthUser";
import providers from "@/lib/api";
import { Throttle } from "@/lib/decorators";
import emitter from "@/lib/emitter";
import { $t } from "@/lib/i18nHelpers";
import { MediaFilesController } from "@/lib/MediaFilesController";
import { getProfileUrl } from "@/lib/urlHelpers";
import { EVENTS } from "@/const";
import BaseAvatar from "@/components/BaseAvatar";
import BaseIcon from "@/components/BaseIcon";

interface MenuItem {
  label: string;
  active?: string;
  name: string;
  to: Location;
  hasNew?: boolean;
  exact?: boolean;
}

@Component({ name: "MainNavigationBar", components: { BaseIcon, BaseAvatar } })
export default class MainNavigationBar extends mixins(WithAuthUser) {
  public unreadMessageThreadsCount = 0;

  public get menuList(): MenuItem[] {
    if (!this.authUser) return [];
    return [
      {
        label: "sci-home-outline",
        active: "sci-home",
        name: $t("Home"),
        to: {
          name: "home",
        },
      },
      {
        label: "sci-account-circle-outline",
        active: "sci-account-circle",
        name: $t("Profile"),
        to: this.profileTo,
        exact: true,
      },
      {
        label: "sci-chat-outline",
        active: "sci-chat",
        name: $t("Messages"),
        to: {
          name: "messageThreads",
        },
        hasNew: this.hasNewMessages,
      },
      {
        label: "sci-bell-outline",
        active: "sci-bell",
        name: $t("Notifications"),
        to: {
          name: "notifications",
        },
        hasNew: false,
      },
      {
        label: "sci-menu",
        name: $t("More"),
        to: {
          name: "more",
        },
      },
    ];
  }

  public get profileTo() {
    return getProfileUrl(this.authUserStrict);
  }

  public get avatarUrl(): string {
    if (!this.authUserStrict.avatar) return "";
    return MediaFilesController.getImageThumbnail(this.authUserStrict.avatar.urlPart, 76);
  }

  public get hasNewMessages() {
    return this.unreadMessageThreadsCount > 0;
  }

  public async getUnreadCount() {
    this.unreadMessageThreadsCount = await providers.MessageThreadsProvider.getUnreadCount();
  }

  @Throttle(3000, { trailing: false })
  public receivedMessage() {
    this.getUnreadCount();
  }

  public hideMenuHandler(hide: boolean = false) {
    const root = document.documentElement;
    if (hide) {
      root.style.setProperty("--safe-bottom-position", "0px");
    } else {
      root.style.setProperty("--safe-bottom-position", "calc(56px + env(safe-area-inset-bottom))");
    }
  }

  public created() {
    this.hideMenuHandler();
    this.getUnreadCount();
    emitter.on<any>(EVENTS.MESSAGES_NEW_MESSAGE, this.receivedMessage);
    emitter.on<any>(EVENTS.MESSAGES_MARKED_READ, this.getUnreadCount);
    emitter.on<any>(EVENTS.MAIN_MENU_HIDE, this.hideMenuHandler);
  }

  public beforeDestroy() {
    this.hideMenuHandler(true);
    emitter.off<any>(EVENTS.MESSAGES_NEW_MESSAGE, this.receivedMessage);
    emitter.off<any>(EVENTS.MESSAGES_MARKED_READ, this.getUnreadCount);
    emitter.off<any>(EVENTS.MAIN_MENU_HIDE, this.hideMenuHandler);
  }
}
